import {
  AdservingPartnerWithMacros,
  AiAdServingPartnerType,
  AdServingPartnerType,
  VastVersion,
  VastVersionName,
} from 'common/src/modules/adServingPartner/adServingPartner.types';
import {AiCampaignType, CampaignType} from 'common/src/modules/campaigns/campaigns.types';
import getMatchingEnumValue from 'common/src/utils/typescriptUtils/getMatchingEnumValue';

function convertDspToAiString(partnerWithMacros: AdservingPartnerWithMacros): string {
  const {partner, macros} = partnerWithMacros;

  const vastVersionNames = partner.supportedVastVersions
    .map((version) => getMatchingEnumValue(VastVersion, VastVersionName, version))
    .filter((display) => display !== undefined)
    .join(', ');

  const videoVastVersionNames = partner.supportedVideoVastVersions
    .map((version) => getMatchingEnumValue(VastVersion, VastVersionName, version))
    .filter((display) => display !== undefined)
    .join(', ');

  const audioVastVersionNames = partner.supportedAudioVastVersions
    .map((version) => getMatchingEnumValue(VastVersion, VastVersionName, version))
    .filter((display) => display !== undefined)
    .join(', ');

  return `DSP: ${partner.displayName}
- Type: ${getMatchingEnumValue(AdServingPartnerType, AiAdServingPartnerType, +partner.type)}
- Description: ${partner.description}
- Max. Animation Length (seconds): ${partner.displayMaxAnimationLengthInSeconds}
- Max. Number of Variations: ${partner.maxCTVCampaignVariationsCount || 'unset'}
- Supported VAST versions: ${vastVersionNames}
- Supported Video VAST versions: ${videoVastVersionNames}
- Supported Audio VAST versions: ${audioVastVersionNames}
- Max. CTV Campaign Variations Count: ${partner.maxCTVCampaignVariationsCount || 'unset'}
- Supported Campaign Types: ${partner.supportedCampaignTypes
    .map((campaignType) => getMatchingEnumValue(CampaignType, AiCampaignType, +campaignType))
    .filter((display) => display !== undefined)
    .join(', ')}
- Macros: 
${macros.map((macro) => `  - Value: '${macro.value}', Clinch Variable: '${macro.name}'`).join('\n')}`;
}

export default convertDspToAiString;
